module.exports = __webpack_public_path__ + "static/media/red-circle.f12c6b81.svg";